import {
  type Locale,
  useLanguagePreference,
  syncLocaleToBackend,
} from "../model/language-preference-store";

/**
 * Syncs the language preference store with the user's persisted locale from the backend.
 *
 * When `pendingLocaleSync` is true (user changed language on the login/signup page
 * before authenticating), pushes the frontend preference to the backend instead of
 * overwriting it. This ensures pre-login language selection is preserved after login.
 */
export const syncLocaleFromMe = (locale: string) => {
  const validLocale = locale === "en" || locale === "nl" ? locale : "nl";
  const store = useLanguagePreference.getState();

  if (store.pendingLocaleSync) {
    useLanguagePreference.setState({ pendingLocaleSync: false });
    if (store.language !== validLocale) {
      syncLocaleToBackend(store.language);
    }
    return;
  }

  if (store.language !== validLocale) {
    store.setLanguageFromBackend(validLocale as Locale);
  }
};
